/**
 * Classifies error as specifically failing required() validation or not
 */
export const isRequiredError = (error: string) => error?.includes('is a required field');
